import styled from "@emotion/styled/macro";

export const MobileModalContent = styled.div`
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    height: 100%;
    border-radius: 20px;
`;